/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="find-in-boutique-sidebar-nav sidebar-block-panel">
    <div class="sidebar-block-content wrapp-fib-container">
      <div class="accordion-list">
        <b-card no-body>
          <b-card-header header-tag="header" role="tab">
            <button v-b-toggle="'stores-accordion'" class="btn btn-none accordion-title d-flex align-items-center justify-content-between">
              <div class="title" v-html="callMessage"></div>
              <svg class="o-icon icon-arrow fill-black" v-if="stores.length"><use xlink:href="#arrow-down"></use></svg>
            </button>
          </b-card-header>
          <b-collapse id="stores-accordion" role="tabpanel" class="stores-accordion">
            <b-card-body>
              <stores-list :stores="stores">
                <template #firstOfList v-if="!isOnlineMode">
                  <div class="wrapp-online-store" v-for="store in onlineStores" :key="store.code">
                    <div class="wrapp-store icon-shop">
                      <button class="btn-store" @click.prevent="goToOnlineStore(store)">
                        <svg class="o-icon fill-black"><use xlink:href="#shop-ecommerce"></use></svg>
                        <span class="text">{{store.label}}</span>
                      </button>
                    </div>
                  </div>
                </template>
              </stores-list>
            </b-card-body>
          </b-collapse>
        </b-card>
        <absolute-loader :showLoader="showLoader"></absolute-loader>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import { changeStore } from 'theme/helpers'
import { localizedByName } from '@/filters/routers'
import filter from 'lodash/filter'
import Config from 'config'
import StoresList from 'theme/components/StoreLocator/StoresList'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'

export default {
  name: 'FindInBoutique',
  props: {
    product: {
      type: Object,
      required: true
    },
    configurableOptions: {
      type: Array,
      required: true
    },
    filterActive: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showLoader: false,
      callMessage: '',
      stores: []
    }
  },
  watch: {
    filterActive: {
      handler: function () {
        this.getStores()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    productLink () {
      if (this.product) {
        let path = '/'
        // width category path
        if (this.$store.state.category.current && this.$store.state.category.current.url_path) {
          path += this.$store.state.category.current.url_path + '/'
        }
        return localizedByName('factoryPage', this.$store, this.$router) + path + this.product.url_key + this.product.url_suffix
      }
      return ''
    },
    isOnlineMode () {
      return this.$store.getters['userAdmin/getOnlineMode']
    },
    onlineStores () {
      return filter(Config.Theme.stores, { isOnlineStore: true })
    },
    currentAddress () {
      return this.$store.getters['userAdmin/getCurrentAddress']
    }
  },
  methods: {
    getStores () {
      const _this = this
      let lat = this.$store.state.userAdmin.current ? this.$store.state.userAdmin.current.latitude : null
      let lng = this.$store.state.userAdmin.current ? this.$store.state.userAdmin.current.longitude : null
      let params = {
        product: this.product.id,
        item: this.product.id,
        qty: 1
      }
      if (this.configurableOptions.length === Object.keys(this.filterActive).length) {
        for (let i in this.filterActive) {
          params[`super_attribute[${i}]`] = this.filterActive[i]
        }
      }

      if (lat !== null && lng !== null) {
        params['coords[lat]'] = parseFloat(lat)
        params['coords[lng]'] = parseFloat(lng)
      }
      this.showLoader = true
      this.$store.dispatch('storeLocator/getProductOnStore', params)
        .then((resp) => {
          if (resp) {
            if (resp && resp.data.error_message) {
              _this.callMessage = _this.$t(resp.data.error_message)
              return resp
            } else {
              let availableStores = filter(resp.data.stores_available, { stock_status: true })
              _this.callMessage = `
                <svg class="o-icon ${availableStores.length ? '' : 'd-none'}"><use xlink:href="#check"></use></svg>
                <span>${_this.$t('available-in-{count}-store', { count: availableStores.length })}</span>
              `
              _this.stores = availableStores
            }
          }
        })
        .finally(() => {
          this.showLoader = false
        })
    },
    goToOnlineStore (onlineStore) {
      const _this = this
      this.$emit('storeChange', true)
      return changeStore({ vm: this, store: this.$store, router: this.$router, boutique: onlineStore, isOnlineStore: true })
        .then(() => {
          _this.$store.commit('quickBuy/setCurrentProductUrlKey', _this.productLink)
          _this.$store.commit('quickBuy/setToggle', true)
          EventBus.$emit('quickView:initProduct', { urlKey: _this.productLink })
        })
    }
  },
  components: {
    StoresList,
    AbsoluteLoader
  }
}
</script>
